<div class="container-fluid mt-3">
	<h4>
		{{(isNewProfile ? 'multi_tariff.profile.add_profile' : 'multi_tariff.profile.edit_profile') | translate}}
	</h4>

	<div class="card mb-3">
		<div class="card-body">
			<div class="row align-items-center mb-3">
				<label class="col-md-2" for="profileName">
					<strong>{{'multi_tariff.profile.name' | translate}} <span>*</span></strong>
				</label>
				<div class="col-md-4">
					<input
						id="profileName"
						type="text"
						class="form-control"
						name="profileName"
						maxlength="100"
						[ngClass]="{'border border-danger': invalidFields?.profile?.name}"
						[(ngModel)]="profile.name"
					/>
				</div>
			</div>

			<div class="row align-items-center">
				<label class="col-md-2" for="currency">
					<strong>{{'multi_tariff.profile.currency' | translate}} <span>*</span></strong>
				</label>
				<div class="col-md-4">
					<ng-select
						id="currency"
						[items]="currencies"
						bindLabel="name"
						bindValue="id"
						name="currency"
						placeholder="{{'multi_tariff.profile.currency' | translate}}"
						[clearable]="false"
						[ngClass]="{'border border-danger': invalidFields?.profile?.currency}"
						[(ngModel)]="profile.currency"
					></ng-select>
				</div>
			</div>
		</div>
	</div>

	<app-multi-tariff-rates
		[rates]="rates"
		[currency]="profile.currency"
		[invalidFields]="invalidFields"
		[readonly]="!hasWriteAccess"
		(ratesChange)="onRatesChange($event)"
	></app-multi-tariff-rates>

	<app-multi-tariff-categories
		[categories]="categories"
		[rates]="rates"
		[currency]="profile.currency"
		[deletedRateIndex]="deletedRateIndex"
		[invalidFields]="invalidFields"
		[readonly]="!hasWriteAccess"
		(categoriesChange)="onCategoriesChange($event)"
	></app-multi-tariff-categories>

	<div class="d-flex justify-content-end my-3">
		<button type="button" class="btn btn-secondary mr-2" (click)="goBack()">{{'g.cancel' | translate}}</button>
		<button *ngIf="hasWriteAccess" type="button" class="btn btn-primary" (click)="saveProfile()">{{'g.save' | translate}}</button>
	</div>
</div>
